
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import InfoBanner from '@/components/shared/InfoBanner.vue';
import StudentComponent from '@/components/profile/Student.vue';

const namespace: string = 'restaurant';

@Component<StudentsComponent>({
	components: {
		InfoBanner,
		StudentComponent
	}
})
export default class StudentsComponent extends Vue {
	@Action('fetchGroupLocations', { namespace }) private fetchGroupLocations!: (restaurantId: string) => Promise<void>;
	@Getter('getUserStudents', { namespace: 'auth' }) private students!: UserStudent[];
	@Getter('getRestaurant', { namespace }) private restaurant!: Restaurant;
	@Getter('getRestaurantGroupLocations', { namespace }) private groupLocations!: GroupLocation[];

	private loading: boolean = false;

	/**
	 * Fetch group locations on mount if part of a group
	 *
	 * @return {Promise<void>}
	 */
	private async created(): Promise<void> {
		window.scrollTo({ top: 0, behavior: 'smooth' });
		if (!this.groupLocations.length) {
			this.loading = true;
			try {
				await this.fetchGroupLocations(this.restaurant.id);
			}
			catch (error) {
				this.$toasted.error(this.$t('profile.students.select_modal.error_loading_locations'), { type: 'error', position: 'top-center' }).goAway(5000);
			}
			finally {
				this.loading = false;
			}
		}
	}

	private redirectTo(path: string): void {
		this.$router.push({ path, query: this.$route.query }).catch(() => {});
	}
}
